import React, { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../../actions/log';
import Toast from '../../../components/Toast/Toast';
import styles from './SoftTagLine.module.less';
import defaultImg from '../../../static/forum_app.svg';
import { CONTEXT } from '../../../config';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default props => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { forumData = {}, logInfo } = props;
  const logInfoData = useSelector(selectLogInfo);

  const [showSoft, setShowSoft] = useState([]);

  useEffect(() => {
    if (forumData && forumData.softInfos && forumData.softInfos.length > 0) {
      let showSoftList = forumData.softInfos.sort((a, b) => {
        return a.name.indexOf('<em>') < 0;
      });
      setShowSoft(showSoftList);
    }
  }, [forumData]);

  const handleSoft = useCallback(soft => {
    if (
      (soft.androidType !== '1' && soft.softId) ||
      (soft.androidType === '1' && soft.packageName)
    ) {
      dispatch(
        logging({
          category: 'C',
          action: 'Forum_Tag_Soft',
          label: '',
          param2: {
            source: logInfo.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softId: soft.softId,
            softName: soft.name,
            packageName: soft.packageName,
            id: forumData.id,
          },
          param3: forumData?.bizInfo || '{}',
        }),
      );
      dispatch(
        logPostInfo({
          source_p: `${logInfo.source}`,
          source_pp: logInfoData.source_p,
        }),
      );
      if (soft.androidType === '1') {
        history.push(
          `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode}/${soft.bizInfo || '{}'}`,
        );
      } else {
        history.push(`${CONTEXT}/detail/soft/${soft.softId}/${soft.bizInfo || '{}'}`);
      }
    } else {
      Toast.error({ content: '该软件尚未上架…' });
    }
  }, []);

  return (
    <div className={styles.forum_item_softs}>
      {showSoft.slice(0, 3).map((item, index) => {
        return (
          <div
            className={styles.forum_item_soft}
            key={index}
            onClick={() => {
              handleSoft(item);
            }}
          >
            <img
              className={styles.forum_item_soft_logo}
              src={item.logoFile || defaultImg}
              alt={''}
            />

            <div
              className={styles.forum_item_soft_name}
              dangerouslySetInnerHTML={{
                __html: item.name,
              }}
            ></div>
          </div>
        );
      })}
    </div>
  );
};
